module.exports = __webpack_public_path__ + "img/spiral-clockwise-top-right.0a82c6de.png";